import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=65fbd4fb"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65fbd4fb')) {
      api.createRecord('65fbd4fb', component.options)
    } else {
      api.reload('65fbd4fb', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=65fbd4fb", function () {
      api.rerender('65fbd4fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/installations/edit.vue"
export default component.exports